import { useLanguage } from "~/apps/corporate/contexts/language.context";
import { LanguageCode } from "~/apps/shared/constants/enums";

const transcriptions = {
  [LanguageCode.EN_US]: {
    buttons: {
      confirm: "Remove",
    },
    title: "Remove Document",
    message: (documentType: string) =>
      `Do you really want to remove this ${documentType}?`,
    fallbackMessage: "Do you really want to remove this document?",
  },
  [LanguageCode.PT_BR]: {
    buttons: {
      confirm: "Remover",
    },
    title: "Remover documento",
    message: (documentType: string) =>
      `Deseja realmente remover esse ${documentType}?`,
    fallbackMessage: "Deseja realmente remover este documento?",
  },
} as const;

export const useRemoveDocumentAlertDialogTranscription = () => {
  const { languageCode } = useLanguage();

  const transcription =
    transcriptions[languageCode as keyof typeof transcriptions];

  return { transcription };
};
